export const EvaluationQuestions = [
	{
		category: 'Økonomi og tilbud',
		questions: [{ index: 1, question: 'Er kalkulation og tilbud gennemgået inden afsendelse til kunden?' }],
	},
	{
		category: 'Kvalitetsledelse',
		questions: [
			{ index: 1, question: 'Er arbejdet anmeldt til Arbejdstilsynet?' },
			{ index: 2, question: 'Er AD05 Sagsorganisation udfyldt korrekt og instruktion udført?' },
		],
	},
	{
		category: 'Afgrænsning og afskærming',
		questions: [
			{ index: 1, question: 'Er arbejdsområdet tydeligt afgrænset og skiltet?' },
			{ index: 2, question: 'Er området afskærmet, opsat 3-kammer sluse og undertryk etableret?' },
		],
	},
	{
		category: 'Støvbegrænsning og rengøring',
		questions: [
			{ index: 1, question: 'Anvendes støvbegrænsende metoder og udstyr?' },
			{ index: 2, question: 'Er der løbende udført rengøring og udført slutrengøring?' },
			{ index: 3, question: 'Er geltapeprøver taget efter slutrengøring?' },
		],
	},
	{
		category: 'Værnemidler',
		questions: [
			{ index: 1, question: 'Anvendes egnede værnemidler korrekt?' },
			{ index: 2, question: 'Er værnemidler rengjort og kontrolleret efter brug?' },
		],
	},
	{
		category: 'Arbejdshygiejne',
		questions: [{ index: 1, question: 'Er der opsat og tilsluttet miljøvogn?' }],
	},
	{
		category: 'Risiko',
		questions: [
			{ index: 1, question: 'Er risikoen begrænset til det nødvendige?' },
			{ index: 2, question: 'Er der udført tilsyn og udført AD06 Tilsynsrapport?' },
			{ index: 3, question: 'Er der udført og opdateret kemisk risikovurdering?' },
		],
	},
	{
		category: 'Affaldshåndtering',
		questions: [
			{ index: 1, question: 'Er asbestholdigt affald anmeldt og bortskaffet korrekt?' },
			{ index: 2, question: 'Er affaldssagen slutmeldt via affaldsmailen?' },
		],
	},
];
